import { IReservationR1InvoiceInfo } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const upsertR1InvoiceInfo = ({
  calculationId,
  payload,
}: {
  calculationId: string;
  payload: IReservationR1InvoiceInfo;
}) => API.put(`/api/accommodation/calculations/${calculationId}/r1-invoice-info`, payload);
